<template>
  <div class="console-wrapper">
    <div class="container">
      <div class="product-wrapper">
        <open-product :product="product" v-if="phone || ip || platform || phoneAttackMonitor || financialAntiFraud"></open-product>
        <recommend-product :product="product" v-if="!phone || !ip || !platform"></recommend-product>
      </div>
      <login-log></login-log>
    </div>
  </div>
</template>

<script>
import OpenProduct from './components/openProduct.vue'
import RecommendProduct from './components/recommendProduct.vue'
import LoginLog from './components/loginLog.vue'
export default {
  components: {
    LoginLog,
    OpenProduct,
    RecommendProduct
  },
  computed: {
    product () {
      return this.$store.state.product
    },
    phone () {
      const arr = this.product.filter((item) => {
        return (item.busi === 'heika_online' || item.busi === 'heika_offline' || item.busi === 'heika_without_mainland_offline') && item.auditflag === '5'
      })
      return arr.length
    },
    ip () {
      const arr = this.product.filter((item) => {
        return item.busi === 'blackipv2_online' || item.busi === 'blackipv2_offline'
      })
      return arr.length
    },
    platform () {
      const arr = this.product.filter((item) => {
        return item.busi === 'antifraud_online' || item.busi === 'antifraud_online'
      })
      return arr.length
    },
    phoneAttackMonitor () {
      return this.product.some((item) => {
        return (
          item.busi === 'group_receive_code_online' ||
          item.busi === 'group_receive_code'
        ) && item.auditflag === '5'
      })
    },
    financialAntiFraud () {
      const productCodes = [
        'bank_card_all_offline',
        'company_account_offline',
        'merchant_online',
        'fraud_victim_payments_online',
        'digital_rmb_offline'
      ]
      return this.product.some((item) => {
        return productCodes.includes(item.busi) && item.auditflag === '5'
      })
    }
  },
  data () {
    return {
    }
  },
  async created () {
  }
}
</script>

<style lang="scss" scoped>
.console-wrapper {
  padding: 24px 32px;
  .container {
    padding-right: 0;
    display: flex;
  }
}
</style>
